import React from "react";
import { t } from "ttag";

import { CRMForm, FormType, WhoAreYouSelect } from "../CRMForm";
import { StateSelect } from "../CRMForm/StateSelect";
import { ButtonPrimary } from "../Clickables";
import { TextField } from "../Forms/Input";
import { FormLayout } from "./CRMForm";
import { ReasonForThisEmail } from "./ReasonForThisEmail";

import styles from "./forms.module.scss";

export const ContactForm = (props: FormLayout) => (
    <CRMForm
        layout="solo"
        type={FormType.CONTACT}
        custom_submit_url={props.custom_submit_url}
    >
        {(disabled, legal) => (
            <>
                <ReasonForThisEmail className={styles.input} />
                <WhoAreYouSelect className={styles.input} />
                <TextField
                    label={t`First Name`}
                    className={styles.input}
                    name="first_name"
                    isRequired
                />
                <TextField
                    label={t`Last Name`}
                    className={styles.input}
                    name="last_name"
                    isRequired
                />
                <TextField
                    label={t`Email Address`}
                    className={styles.input}
                    name="email_address"
                    isRequired
                    type="email"
                />
                <TextField
                    label={t`Phone Number`}
                    className={styles.input}
                    name="phone"
                />

                <TextField
                    label={t`City`}
                    className={styles.input}
                    name="city"
                    isRequired
                />
                <StateSelect className={styles.input} />
                <TextField
                    label={t`ZIP Code`}
                    className={styles.input}
                    name="zip_code"
                    isRequired
                />
                <TextField
                    label={t`If you are working with a dealer, please specify the dealer name`}
                    className={styles.input}
                    name="dealer_name"
                />
                <TextField
                    label={t`Message`}
                    className={styles.input}
                    name="message"
                    textArea={true}
                />
                {legal}
                <div className={styles.submitContainer}>
                    <ButtonPrimary disabled={disabled} type="submit">
                        {t`Submit`}
                    </ButtonPrimary>
                </div>
            </>
        )}
    </CRMForm>
);
